module.exports = __webpack_public_path__ + "img/marker_one_green1.59c13a45.png";